<div class="timeline">
    <div class="date">
        <span [i18n]="'local-loads.search.details.planned-arrival'"></span>
        <span>{{ (plannedArrival | date:'y-MM-dd HH:mm') || '-' }}</span>
        <label *ngIf="plannedArrival != null && timezoneOffset != null" class="timezone-offset">
            <span>{{ timezoneOffset }}</span>
        </label>
    </div>
    <div (click)="showEtaDetails()"
         class="date" [class.planned]="eta == null" [ngClass]="'eta-type-'+etaType">
        <span [i18n]="'local-loads.search.details.eta'"></span>
        <span>{{ (eta | date:'y-MM-dd HH:mm') || '-' }}</span>
        <label *ngIf="eta != null && timezoneOffset != null" class="timezone-offset">
            <span>{{ timezoneOffset }}</span>
        </label>
        <div class="eta-type">
            <app-delivery-eta-type-icon [etaType]="etaType"></app-delivery-eta-type-icon>
        </div>
    </div>
    <div class="date" [ngClass]="{ 'done': !!arrival, 'planned': !arrival }">
        <span [i18n]="'local-loads.search.details.actual-arrival'"></span>
        <span *ngIf="!arrivalExclamation else exclamationTemplate">{{ (arrival | date:'y-MM-dd HH:mm') || '-' }}</span>
        <label *ngIf="arrival != null && timezoneOffset != null" class="timezone-offset">
            <span>{{ timezoneOffset }}</span>
        </label>
    </div>
    <div class="date" [ngClass]="{ 'done': !!departure, 'planned': !departure }">
        <span [i18n]="'local-loads.search.details.actual-departure'"></span>
        <span *ngIf="!departureExclamation else exclamationTemplate">{{ (departure | date:'y-MM-dd HH:mm') || '-' }}</span>
        <label *ngIf="departure != null && timezoneOffset != null" class="timezone-offset">
            <span>{{ timezoneOffset }}</span>
        </label>
    </div>
</div>

<ng-template #exclamationTemplate>
    <span><i class="fas fa-exclamation-triangle"></i> Missing date in BY</span>
</ng-template>
